import React from 'react'

const Loader = () => {
  return (
    <div class='w-screen h-screen relative'>
      <div class='loader'>
        <div>ResView</div>
        <div class='inner' />
      </div>
    </div>
  );
}

export default Loader